import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import Dialog from './dialog'
import Explanation from './explanation'

type ArgumentProps = {
    userImage: string
    name: string
}

const Argument: React.FunctionComponent<ArgumentProps> = ({ name, userImage }) => {
    const { t } = useTranslation('landing')

    const problem = t(`selling_points.${name}.problem`)
    const solution = t(`selling_points.${name}.solution`)
    const explanation = t(`selling_points.${name}.explanation`)

    return (
        <Container>
            <Dialog problem={problem} solution={solution} userImage={userImage} />
            <Explanation explanation={explanation} />
        </Container>
    )
}

const Container = styled.div`
    display: grid;

    grid-gap: 16px;
`

export default Argument